import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProveedorAddComponent } from './proveedor-add/proveedor-add.component';
import { ProveedorListComponent } from './proveedor-list/proveedor-list.component';
import { CompraListComponent } from './compra-list/compra-list.component';
import { CompraAddComponent } from './compra-add/compra-add.component';
import { ProveedorEditComponent } from './proveedor-edit/proveedor-edit.component';
import { RetencionesCompraListComponent } from './retenciones-compra-list/retenciones-compra-list.component';
import { RetencionesCompraAddComponent } from './retenciones-compra-add/retenciones-compra-add.component';
import { PagoListComponent } from './pago-list/pago-list.component';
import { PagoAddComponent } from './pago-add/pago-add.component';
import { GastoListComponent } from './gasto-list/gasto-list.component';
import { GastoAddComponent } from './gasto-add/gasto-add.component';
import { NotaCreditoCompraListComponent } from './nota-credito-compra-list/nota-credito-compra-list.component';
import { NotaCreditoCompraAddComponent } from './nota-credito-compra-add/nota-credito-compra-add.component';
import { PagoGrupoComponent } from './pago-grupo/pago-grupo.component';
import { LiquidacionCompraAddComponent } from './liquidacion-compra-add/liquidacion-compra-add.component';
import { LiquidacionCompraListComponent } from './liquidacion-compra-list/liquidacion-compra-list.component';
import { OrdenCompraListComponent } from './orden-compra-list/orden-compra-list.component';
import { OrdenCompraAddComponent } from './orden-compra-add/orden-compra-add.component';

const routes: Routes = [
  { path: 'proveedores/crear', component: ProveedorAddComponent },
  { path: 'proveedores-edit', component: ProveedorEditComponent },
  { path: 'proveedores-list', component: ProveedorListComponent },
  { path: 'compras-list', component: CompraListComponent },
  { path: 'compras/crear', component: CompraAddComponent },
  { path: 'retenciones-list', component: RetencionesCompraListComponent },
  { path: 'retenciones/crear', component: RetencionesCompraAddComponent },
  { path: 'pago-list', component: PagoListComponent },
  { path: 'pago/:id', component: PagoAddComponent },
  { path: 'pago-grupo', component: PagoGrupoComponent },
  { path: 'gastos-list', component: GastoListComponent },
  { path: 'gastos/crear', component: GastoAddComponent },
  { path: 'notacredito-list', component: NotaCreditoCompraListComponent },
  { path: 'notacredito/crear', component: NotaCreditoCompraAddComponent },
  { path: 'liquidacion-compra/crear', component: LiquidacionCompraAddComponent },
  { path: 'liquidacion-compra-list', component: LiquidacionCompraListComponent },
  { path: 'orden-compra-list', component: OrdenCompraListComponent },
  { path: 'orden-compra-add', component: OrdenCompraAddComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComprasRoutingModule { }



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/compras-routing.module.ts